import React, { useRef, useEffect } from "react"
import { useHits, Pagination, useQueryRules } from "react-instantsearch"
import SearchHit from "./SearchHit"
import FormatAndRenderSearchPromoCard from "../../utils/organism-formatting/SearchPromoCard/FormatAndRenderSearchPromoCard"

function CustomQueryRuleCustomData(props) {
  const { items } = useQueryRules(props)

  const { searchPromoCardsData, locale } = props

  return (
    <div
      className={` ${
        searchPromoCardsData?.length > 1
          ? "nav-search__hits--promo-card--multiple"
          : "nav-search__hits--promo-card"
      }`}
    >
      {items?.map(({ display_search_promo_card: displayPromoCard }) => {
        if (displayPromoCard) {
          return (
            <FormatAndRenderSearchPromoCard
              data={searchPromoCardsData}
              locale={locale}
            />
          )
        }
      })}
    </div>
  )
}

const connectHits = Component => {
  const Hits = props => {
    const data = useHits()
    return <Component {...props} {...data} />
  }

  return Hits
}

export const Hits = ({
  hits,
  isSecondIndex,
  locale,
  totalHits,
  searchWrapperRef,
  bannerComponent,
  searchPromoCardsData,
}) => {
  const paginationWrapperRef = useRef(null)

  const wrapperClickHandler = e => {
    if (
      window &&
      e?.target?.classList?.contains("ais-Pagination-link") &&
      e?.target?.nodeName === "A"
    ) {
      searchWrapperRef?.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      })
    }
  }

  useEffect(() => {
    if (document && paginationWrapperRef?.current) {
      paginationWrapperRef?.current?.addEventListener("click", e =>
        wrapperClickHandler(e)
      )
    }

    return () => {
      paginationWrapperRef?.current?.removeEventListener("click", e =>
        wrapperClickHandler(e)
      )
    }
  }, [paginationWrapperRef?.current])

  return (
    <>
      <div
        className={`nav-search__hits ${
          isSecondIndex ? "nav-search__hits--second-index" : ""
        }`}
      >
        <CustomQueryRuleCustomData
          searchPromoCardsData={searchPromoCardsData}
          locale={locale}
        />
        <ul className="nav-search__hits--list">
          {hits?.map(hit => (
            <li key={hit.objectID} className="nav-search__hits--item">
              <SearchHit hit={hit} locale={locale} />
            </li>
          ))}
        </ul>
        {totalHits > 5 && (
          <div ref={paginationWrapperRef}>
            <Pagination showFirst={false} showLast={false} padding={2} />
          </div>
        )}
      </div>
    </>
  )
}

const CustomHits = connectHits(Hits)

export default CustomHits
